import { Image, Radio, Typography } from '@smartgift/frontend-toolkit';
import styled from 'styled-components';

const Experience = styled.div`
  .text-editor {
    .action-buttons {
      bottom: auto;
      right: 8px;
      top: 132px;
    }
  }
`;

const RedemptionWindowWrapper = styled.div`
  display: flex;
  gap: 10px;
  margin-bottom: 20px;

  ${Radio.S.InputLabel} {
    white-space: nowrap;
  }
`;

const OverviewWrapper = styled.div``;

const DigitalWrapperContainer = styled.div`
  ${Image.S.Image} {
    box-shadow: var(--shadow-s);
  }
`;

const ViewRecipientExperienceWrapper = styled.div`
  background-color: var(--color-gray-25);
  border-radius: var(--size-border-radius-md);
  margin-bottom: 16px;
`;

const GiftsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const Row = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

const AddingMethods = styled.div`
  margin-top: 12px;

  &::after {
    background-color: var(--color-accent-secondary-weaker);
    clear: both;
    content: '';
    display: block;
    height: 1px;
    margin-top: 16px;
    width: 100%;
  }
`;

const AddingMethodsBody = styled.div`
  align-items: center;
  display: flex;
`;

const AddingMethodsTitle = styled(Typography)`
  width: 180px;
`;

const AddingMethodsList = styled.div`
  align-items: center;
  display: flex;
  gap: 40px;
`;

const AddingMethodsListItem = styled(Radio)``;

const Description = styled(Typography)`
  margin-top: 24px;
`;

const EmptySelectedCharityPlaceholderWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-top: 16px;
`;

export {
  AddingMethods,
  AddingMethodsBody,
  AddingMethodsList,
  AddingMethodsListItem,
  AddingMethodsTitle,
  Description,
  DigitalWrapperContainer,
  EmptySelectedCharityPlaceholderWrapper,
  Experience,
  GiftsWrapper,
  OverviewWrapper,
  RedemptionWindowWrapper,
  Row,
  ViewRecipientExperienceWrapper
};
